module.exports = __webpack_public_path__ + "static/gallery_wild_1_thumb-a020bb5cfc1b83d114379c6003815813.jpg";